import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '@/layout/DashboardLayout'
import AuthLayout from '@/layout/AuthLayout'
Vue.use(Router)

export default new Router({
  linkExactActiveClass: 'active',
  routes: [
    
    {
      path: '/',
      redirect: 'login',
      component: AuthLayout,
      children: [
        {
          path: '/login',
          name: 'login',
          component: () => import('./views/Login.vue')
        }
      ]
    },
    {
      path: '/',
      redirect: 'dashboard',
      component: DashboardLayout,
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('./views/Dashboard.vue')
        },
        {
          path: '/facture',
          name: 'facture',
          component: () => import('./views/Facture.vue')
        },
        {
          path: '/fournisseur',
          name: 'fournisseur',
          component: () => import('./views/Fournisseur.vue')
        },
        {
          path: '/devise',
          name: 'devise',
          component: () => import('./views/Devise.vue')
        },
      ]
    }
  ]
})
